import { render } from "./AILoading.vue?vue&type=template&id=0e987cd4&scoped=true"
const script = {}

import "./AILoading.vue?vue&type=style&index=0&id=0e987cd4&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e987cd4"]])

export default __exports__